import { Link } from '@gogame/navigation';

export const tapjoyBidUpdateLink = new Link('tapjoy-bid-update');
